/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {theme, pxToEm, replacePXinStringWithEM, disable, nthChildIterator} from '@insticator/insticator-ui';



/* ++++++++++ --------------- LABEL ASSIGNMENT COLLECTION ITEM : STYLES --------------- ++++++++++ */
export default {
    labelassignmentitem: {
        // display: 'inline-block',
        background: `rgba(6, 43, 117, 0.05)`,
        borderRadius: pxToEm(4),
        fontSize: pxToEm(12),
        padding: replacePXinStringWithEM('5px 8px'),
        marginRight: pxToEm(8),
        marginTop: pxToEm(4),
        marginBottom: pxToEm(4),

        '& .itemtext': {
            marginRight: pxToEm(8)
        },
        '& .itemicon': {
            color: 'rgba(6, 43, 117, 0.5)'
        },
        '&:hover': {
            background: `rgba(6, 43, 117, 0.05)`,
            '& .itemicon': {
                filter: 'brightness(85%)',
                cursor: 'pointer',
                color: theme.color.attention.dark.swatch,
                transition: 'color 0.5s ease'
            }
        },

    }
};
